module.exports = __webpack_public_path__ + "static/media/spin_mercedes.772ff2ea.png";